import type { Page } from "../../../../common/types/base/BaseEntity";
import type httpRequest from "./index";
import { confirmable } from "@/utils/decorator/confirmable";

export class BaseService<E, V, P, F> {
    protected readonly path!: string;
    protected readonly service!: typeof httpRequest;
    constructor(path: string, service: typeof httpRequest) {
        this.path = path;
        this.service = service;
    }

    /**
     * 主页数据
     */
    public async paging(params: P): Promise<Page<V>> {
        const { data } = await this.service.get(`${this.path}/paging`, { params });
        return data;
    }

    /**
     * 下拉选框列表数据
     */
    public async selector(params: any): Promise<Array<E>> {
        const { data } = await this.service.get(`${this.path}/selector`, { params });
        return data;
    }

    /**
     * 根据ID查询
     * @param id
     */
    public async get(id: number | string): Promise<E> {
        const { data } = await this.service.get(`${this.path}/${id}`);
        return data;
    }

    /**
     * 根据ID查询
     * @param id
     */
    public async getInfo(id: number | string): Promise<V> {
        const { data } = await this.service.get(`${this.path}/vo/${id}`);
        return data;
    }

    /**
     * 创建实例
     * @param form
     */
    @confirmable("是否提交")
    public async create(form: F): Promise<E> {
        for (const key in form) {
            const value = form[key];
            if (value === undefined || value === null || value === "") {
                delete form[key];
            }
        }
        const { data } = await this.service.post(this.path, form, {
            loading: true
        });
        return data;
    }

    /**
     * 更新实例
     * @param id
     * @param form
     */
    @confirmable("是否提交")
    public async update(id: number | string, form: F) {
        const { data } = await this.service.put(`${this.path}/${id}`, form, {
            loading: true
        });
        return data;
    }

    /**
     * 删除实例
     * @param id
     */
    public async delete(id: number | string) {
        const { data } = await this.service.delete(`${this.path}/${id}`);
        return data;
    }
}
